"use client";

import {
  AudioBufferSource,
  BufferTarget,
  Output,
  WavOutputFormat,
} from "mediabunny";

import { AudioTargetFormat } from "@/utils/audio/types";

export const audioBufferToWav = async ({
  audioBuffer,
  targetFormat,
}: {
  audioBuffer: AudioBuffer;
  targetFormat: AudioTargetFormat;
}): Promise<Blob> => {
  const output = new Output({
    format: new WavOutputFormat(),
    target: new BufferTarget(),
  });

  const audioSource = new AudioBufferSource({
    codec: "pcm-s16",
    ...(targetFormat === null ? {} : { transform: targetFormat }),
  });
  output.addAudioTrack(audioSource);
  await output.start();
  await audioSource.add(audioBuffer);
  await output.finalize();

  const buffer = output.target.buffer;
  if (buffer === null) {
    throw new Error("WAV encoding produced no output");
  }
  return new Blob([buffer], { type: "audio/wav" });
};
